// extracted by mini-css-extract-plugin
export var header = "_in-0";